module.exports = __webpack_public_path__ + "img/icon-project-end.e03ef8d2.svg";